"use client";

import * as React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import { Link } from "@/components/common/Link";
const teachers = [{
  name: "Teacher A",
  position: "Senior Dharma Teacher",
  bio: "Specializes in mindfulness and Zen meditation, with over 20 years of practice.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1444982/img/teacher_mindfulness_zen.png"
}, {
  name: "Teacher B",
  position: "Retreat Coordinator",
  bio: "Experienced in guiding retreats and facilitating group practices.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1444982/img/teacher_retreat_coordinator.png"
}, {
  name: "Teacher C",
  position: "Dharma Speaker",
  bio: "Focuses on integrating teachings into daily life and community service.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1444982/img/teacher_dharma_speaker.png"
}, {
  name: "Teacher D",
  position: "Youth and Community Outreach",
  bio: "Dedicated to making Dharma teachings accessible to all ages.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1444982/img/teacher_youth_outreach.png"
}];
export default function MeetOurTeachers() {
  const {
    ref: groupRef,
    isVisible: groupVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: cardsRef,
    isVisible: cardsVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section className="relative min-h-screen bg-light-background py-16 px-4 sm:px-8 lg:px-16">
      {}
      <div className="absolute inset-0 opacity-40 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1444982/img/moss_texture_background.png)] bg-repeat" />

      <div className="relative max-w-7xl mx-auto">
        {}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-display text-foreground-light mb-4">
            Meet Our Teachers
          </h2>
          <p className="text-xl text-foreground-light/80 max-w-2xl mx-auto leading-relaxed">
            We are four Dharma friends and teachers who wish to share with others our love of Dharma and our practice. We regularly teach Dharma programs and retreats individually and together at the Sati Center for Buddhist Studies and the Insight Meditation Center and the Insight Retreat Center in California.
          </p>
        </div>

        {}
        <div ref={groupRef} className="flex justify-center mb-20 transition-transform duration-[800ms] ease-[var(--ease-smooth)]" style={{
        transform: groupVisible ? "translateY(0)" : "translateY(40px)",
        opacity: groupVisible ? 1 : 0
      }}>
          <div className="relative w-full max-w-4xl">
            <div className="block">
              <div className="relative overflow-hidden rounded-lg shadow-strong" style={{
              aspectRatio: "16/9"
            }}>
                <img src="https://profound-pup.10web.cloud/wp-content/uploads/2025/11/IMG_4177.heic-scaled.jpg" alt="Four Dharma Friends Group Portrait" className="w-full h-full object-cover" />
              </div>
              <div className="text-center mt-4">
                <Link to="https://www.insightmeditationcenter.org/teachers-and-dharma-leaders/" className="text-foreground-light hover:text-primary transition-colors duration-[var(--duration-medium)] text-base">
                  David Lorey, Ying Chen, Diana Clark, Kim Allen (from Left to Right)
                </Link>
              </div>
            </div>
          </div>
        </div>

        {}
        <div ref={cardsRef} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {teachers.map((teacher, i) => <div key={i} data-index={i} className="transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)]" style={{
          opacity: cardsVisible ? 1 : 0,
          transitionDelay: cardsVisible ? `${i * 150}ms` : "0ms"
        }}>
              <HoverCard>
                <HoverCardTrigger asChild>
                  <div className="group cursor-pointer">
                    
                  </div>
                </HoverCardTrigger>

                <HoverCardContent side="top" className="w-72 glass-effect border border-border-strong">
                  <Card className="border-0 shadow-none bg-transparent">
                    <CardHeader className="px-0 py-0">
                      <CardTitle className="text-foreground-light text-lg">
                        {teacher.name}
                      </CardTitle>
                      <CardDescription className="text-muted text-sm">
                        {teacher.position}
                      </CardDescription>
                    </CardHeader>
                    <CardContent className="px-0 py-3">
                      <p className="text-foreground-light text-sm leading-relaxed">
                        {teacher.bio}
                      </p>
                    </CardContent>
                  </Card>
                </HoverCardContent>
              </HoverCard>
            </div>)}
        </div>
      </div>
    </section>;
}